import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTechnicalRepresentative } from 'app/actions/TechnicalRepresentativeActions';
import { getTechnicalRepresentative } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function TechnicalRepresentativeContainer(props) {
    let dispatch = useDispatch();
    let technical = useSelector(getTechnicalRepresentative);
    const data={
        idRol: '1'
    }
    useEffect(() => {
        if (isEmpty(technical)) fetchTechnicalRepresentativeAction();
    }, []);
    const fetchTechnicalRepresentativeAction = () => dispatch(fetchTechnicalRepresentative(data));
    return (props.children({ technical }));
}

// https://appsdev.cotemar.com.mx/ERapidsApi/api/Responsibles?idRol=1&